import clsx from 'clsx';
import styles from './fact-tile.module.scss';

interface FactTileProps {
  label: string;
  value: string;
  className?: string;
}

export default function FactTile({ label, value, className }: FactTileProps) {
  return (
    <div className={clsx(styles.fact, className)}>
      <span className={styles.label}>{label}</span>
      <b className={styles.value}>{value}</b>
    </div>
  );
}
